import { create } from 'zustand';

const useStore = create(() => ({
  users: null,
  reports: null,
  alertData: null,
  currentProfile: null,
  locale: null,
  loggedUser: null,
  generateCsvBtn: {
    show: true,
    disabled: false,
  },
  downloadCsvBtn: {
    show: false,
    disabled: false,
  },
  updateCsvBtn: {
    show: false,
    disabled: false,
  },
}));

const DUMMIES_USERS = [
  {
    federationIdentifier: '1',
    name: 'Nuovo Ingresso',
    email: 'pier@pier.com',
  },
  {
    federationIdentifier: '2',
    name: 'Pier',
    email: 'pier@pier.com',
  },
];

const DUMMY_REPORTS = [
  {
    federationIdentifier: '1',
    name: 'Nuovo Ingresso',
    email: 'pier@pier.com',
    allMatchmaking: 10,
    todayMatchmaking: 10,
  },
  {
    federationIdentifier: '1',
    name: 'Nuovo Ingresso',
    email: 'pier@pier.com',
    allMatchmaking: 10,
    todayMatchmaking: 10,
  },
  {
    federationIdentifier: '2',
    name: 'Nuovo Ingresso',
    email: 'pier@pier.com',
    allMatchmaking: 10,
    todayMatchmaking: 10,
  },
  {
    federationIdentifier: '1',
    name: 'Nuovo Ingresso',
    email: 'pier@pier.com',
    allMatchmaking: 10,
    todayMatchmaking: 10,
  },
  {
    federationIdentifier: '1',
    name: 'Nuovo Ingresso',
    email: 'pier@pier.com',
    allMatchmaking: 10,
    todayMatchmaking: 10,
  },
];

export { useStore as useMatchMakingStore, DUMMIES_USERS, DUMMY_REPORTS };
